import { useEffect } from 'react';

import type { EnrollmentChoices } from 'bundles/enroll-common/components/xdp/withEnrollment';
import type { ModalType } from 'bundles/enroll-modal/hooks/useEnrollmentModalState';
import { MODAL_TYPES } from 'bundles/enroll-modal/hooks/useEnrollmentModalState';
import paymentsExperiments from 'bundles/epic/clients/payments';
import { useGenerateEnrollModalImpressionForHighIncomeCountryPricingTest } from 'bundles/payments-common/utils/highIncomeCountryPricingTestUtils';
import { generateImpressionForBillingEngineDlocalAB } from 'bundles/payments-common/utils/stripeUtils';

export type UseEnrollModalExperimentsProps = {
  activeModal: ModalType | null;
  enrollmentAvailableChoices?: EnrollmentChoices;
  courseId: string;
  s12nId?: string;
  isAnAuthenticatedUser: boolean;
};

export type UseEnrollModalExperimentsResult = {
  shouldPreloadEnrollModal: boolean;
};

/**
 * Centralizes the enroll modal's EPIC experiment impressions so the orchestrator
 * stays out of the pricing-test plumbing.
 */
export const useEnrollModalExperiments = ({
  activeModal,
  enrollmentAvailableChoices,
  courseId,
  s12nId,
  isAnAuthenticatedUser,
}: UseEnrollModalExperimentsProps): UseEnrollModalExperimentsResult => {
  useGenerateEnrollModalImpressionForHighIncomeCountryPricingTest({
    enrollmentAvailableChoices,
    courseId,
    s12nId,
    skip: activeModal !== MODAL_TYPES.ENROLL, // only generate impression upon opening the enroll modal
  });

  useEffect(() => {
    if (activeModal === MODAL_TYPES.ENROLL && isAnAuthenticatedUser && enrollmentAvailableChoices?.canSubscribeToS12n) {
      generateImpressionForBillingEngineDlocalAB();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeModal]);

  return {
    shouldPreloadEnrollModal: paymentsExperiments.get('preloadEnrollModalEnabled'),
  };
};

export default useEnrollModalExperiments;
